<template>
  <div>
    <b-table
      striped
      responsive
      hover
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template #cell(show_details)="row">
        <b-button size="sm" @click="toggleRow(row, row.item)" class="mr-2">
          {{ row.detailsShowing ? "-" : "+" }}
        </b-button>
      </template>

      <template #row-details="row">
        <div class="d-none">{{ row.item.lastUpdatedTime }}</div>
        <div v-if="row.item.items === undefined">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
        <div v-if="row.item.items !== undefined">
          <b-table
            striped
            responsive
            hover
            :items="row.item.items"
            :fields="keywordItemFields"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:cell(productPrice)="data">
              <div class="d-flex justify-content-center">
                ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
              </div>
            </template>
            <template v-slot:cell(grandTotal)="data">
              <div class="d-flex justify-content-center">
                ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
              </div>
            </template>
            <template v-slot:cell(discount)="data">
              <div class="d-flex justify-content-center">
                ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
              </div>
            </template></b-table
          >
        </div>
      </template>
      <template v-slot:cell(grandTotal)="data">
        <div class="d-flex justify-content-center">
          ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="filter.paging.pageNo"
      :total-rows="filter.paging.total"
      :per-page="filter.paging.perPage"
      class="m-md-0"
      @change="onPageChange"
      align="right"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  props: {
    liveId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      items: null,
      filter: {
        livePostId: 0,
        paging: {
          pageNo: 1,
          perPage: 10,
          total: 0,
        },
      },
      fields: [
        {
          key: "show_details",
          label: "Show Details",
          class: "w-80px",
        },
        {
          key: "keyword",
          label: "Keyword ที่พิมพ์มา",
          class: "w-100px",
        },
        {
          key: "keywordCount",
          label: "จำนวนหมวดหมู่ Keyword",
          class: "w-100px",
        },
        {
          key: "orderCount",
          label: "คำสั่งซื้อ",
          class: "w-100px",
        },
        {
          key: "grandTotal",
          label: "ยอดคำสั่งซื้อ",
          class: "w-100px",
        },
      ],
      keywordItemFields: [
        {
          key: "show_details",
          label: "Show Details",
          class: "w-80px",
        },
        {
          key: "keyword",
          label: "Keyword ที่พิมพ์มา",
          class: "w-100px",
        },
        {
          key: "keywordCount",
          label: "จำนวนหมวดหมู่ Keyword",
          class: "w-100px",
        },
        {
          key: "orderCount",
          label: "คำสั่งซื้อ",
          class: "w-100px",
        },
        {
          key: "grandTotal",
          label: "ยอดคำสั่งซื้อ",
          class: "w-100px",
        },
      ],
      isBusy: false,
    };
  },
  created() {
    this.filter.livePostId = this.liveId;
    this.getKeywords();
  },
  methods: {
    async getKeywords() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/livepost/Keyword/list`, this.filter)
        .then((data) => {
          console.log("get kewords resposne", data);
          if (data.result == 1) {
            this.items = data.detail.dataList;
            this.filter.total = data.detail.count;
          }
        });
      this.isBusy = false;
    },
    onPageChange(page) {
      this.filter.paging.pageNo = page;
      this.getKeywords();
    },
    async getKeywordtems(keyword) {
      await this.axios
        .get(`${this.$baseUrl}/livepost/KeywordDetail/${keyword.liveReplyId}`)
        .then((data) => {
          console.log("get keyword item response", data);
          if (data.result == 1) {
            keyword.items = data.detail;
            keyword.lastUpdatedTime = "2021";
          }
        });
    },
    toggleRow(row, keyword) {
      row.toggleDetails();
      if (keyword.items === undefined) {
        this.getKeywordtems(keyword);
      }
    },
  },
};
</script>

<style></style>
